import { appConstants } from '../constants/app';

const initialState = {
  globalSettings: {
    basePath: '',
    staticPath: '',
    countries: [],
  },

  settings: {
    stream: [],
    site: [],
    offer: {},
  },

  authSettings: {
    isRecaptchaLoaded: true,
  },
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case appConstants.SET_GLOBAL_SETTINGS_SUCCESS:
      return {
        ...state,
        globalSettings: {
          ...state.globalSettings,
          ...action.settings,
        },
      };
    case appConstants.SET_SITE_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          site: action.settings,
        },
      };

    case appConstants.SET_OFFERS_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          offer: action.settings,
        },
      };

    case appConstants.SET_AUTH_SETTINGS_SUCCESS:
      return {
        ...state,
        authSettings: {
          ...state.authSettings,
          ...action.settings,
        },
      };
    case appConstants.RECAPTCHA_LOADING_SUCCESS:
      return {
        ...state,
        authSettings: {
          ...state.authSettings,
          isRecaptchaLoaded: true,
        },
      };
    default:
      return state;
  }
};
